/* eslint-disable no-console */
import React from 'react'
import { Input, DatePicker, Row, Col, Card, Typography, Button, Tooltip, Table, Space, Modal } from 'antd'
import { CalendarOutlined, ReloadOutlined } from '@ant-design/icons'
import moment from 'moment'
import './scrubCopyManager.css'
import Cookie from 'universal-cookie'
import { station } from '../../../../constants/constants'
import { Http } from '../../../../utils'
import ScrubCopy from './scrubCopy'

const getComplianceClass = (value) => {
  if (value >= 90) {
    return 'scm-compliance-high'
  }
  if (value >= 80) {
    return 'scm-compliance-mid'
  }
  return 'scm-compliance-low'
}
const { Search } = Input
const cookies = new Cookie()
const { Title } = Typography
class ScrubCopyManager extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      query: '',
      date: moment().tz(cookies.get('timezone')).format('YYYY-MM-DD'),
      flights: [],
      station: cookies.get('station') || station,
      modalVisible: false,
      isModalView: false,
      selectedRowKeys: [],
      data: {},
      priorityData: [],
    }
    this.eventSource = null
  }

  componentDidMount() {
    this.fetchPriority()
    this.fetchList()
    this.startEvent()
    if (typeof window !== 'undefined') {
      const isModalView = window.innerWidth < 1200
      this.setState({ isModalView })
    }
  }

  componentWillUnmount() {
    if (this.eventSource) {
      this.eventSource.close()
    }
  }

  startEvent = () => {
    if (this.eventSource) {
      this.eventSource.close()
    }
    this.eventSource = new EventSource(process.env.REACT_APP_API_URL + `events?pgtype=sc&stn=${this.state.station}`)
    this.eventSource.onmessage = (event) => {
      const data = JSON.parse(event.data)
      let flightData = data?.DETAILS?.data
      if (data?.msg == 'scrub_copy') {
        this.setState((prevState) => {
          const updatedFlights = prevState.flights.map((flight) => {
            if (flight.id === flightData.id) {
              return {
                ...flight,
                scrub_data: flightData.scrub_data 
              }
            }
            return flight
          })
          return { flights: updatedFlights }
        })
      }
    }
  }

  fetchPriority = () => {
    Http.get('products_priority?station=DOD').then(({ data }) => {
      if (data?.data?.length > 0) {
        this.setState({ priorityData: data?.data?.[0]?.prod_prior_list || [] })
      }
    })
  }

  fetchList = () => {
    let headers = { station: this.state.station }
    Http.get('/scrub_flight_list', {
      params: { date: this.state.date },
      headers
    })
      .then(({ data }) => {
        this.setState({ flights: data.data })
      })
  }
  formatDecimal = (value) => {
    if (value && value.toString().includes('.')) {
      const decimalPlaces = value.toString().split('.')[1].length
      if (decimalPlaces > 2) {
        return parseFloat(value).toFixed(2)
      }
    }
    return value
  }

  handleSearch = (event) => {
    this.setState({ query: event.target.value })
  }

  handleDateChange = (date) => {
    this.setState({ date: date ? moment(date).format('YYYY-MM-DD') : null }, () => {
      this.fetchList()
    })
  }

  handleRefresh = () => {
    this.fetchList()
  }

  handleSelectScrubCopy = (record) => {
    if (!record) {
      return
    }
    const selectedRowKey = record.id || record.key
    this.setState({
      selectedRowKeys: selectedRowKey ? [selectedRowKey] : [],
      modalVisible: this.state.isModalView,
      data: record,
    })
  }

  getVisibleFlights = () => {
    const { flights, query } = this.state
    const normalizedQuery = query.trim().toLowerCase()

    if (!normalizedQuery) {
      return flights
    }

    return flights.filter((flight) => (
      flight.flight_num?.toString().toLowerCase().includes(normalizedQuery)
      || flight.dest_stn.toLowerCase().includes(normalizedQuery)
    ))
  }

  renderHeader = () => {
    const { date, flights } = this.state
    const compliance = flights => ((flights.reduce((acc, flight) => acc + (flight.scrub_data?.compliance || 0), 0) / flights.length) || 0)
    const completion = flights => ((flights.reduce((acc, flight) => acc + (flight.scrub_data?.completion || 0), 0) / flights.length) || 0)
    
    return (
      <>
        <Row gutter={[8, 8]} align='middle'>
          <Col xs={24} lg={24}>
            <Space direction='horizontal' size={16} className='scm-header-space'>
              <Title level={5} className='mb-0'>{this.state.station} Scrub Copy Manager</Title>
              <Tooltip title='Refresh'>
                <Button type='ghost' className='image-btn scm-refresh-btn' onClick={this.handleRefresh}>
                  <ReloadOutlined />
                </Button>
              </Tooltip>
            </Space>
          </Col>
          <Col xs={24} lg={24}>
            <Row gutter={[16, 16]} align='bottom' className='scm-search-row'>
              <Col flex='auto'>
                <Row gutter={[16, 16]} align='middle' className='scm-date-row'>
                  <Col flex='0 1 180px'>
                    <div>
                      <label className='custom-label' htmlFor='from_date'>Flight Date</label>
                      <DatePicker
                        className='scm-date'
                        allowClear={false}
                        value={date ? moment(date) : null}
                        placeholder='Select Date'
                        suffixIcon={<CalendarOutlined />}
                        onChange={this.handleDateChange}
                      />
                    </div>
                  </Col>
                </Row>
              </Col>
              <Col xs className='scm-stats-col'>
                <div className='scm-stats'>
                  <div><span>% Completion:</span><strong>{`${this.formatDecimal(completion(flights))}%`}</strong></div>
                  <div><span>% Compliance:</span><strong>{`${this.formatDecimal(compliance(flights))}%`}</strong></div>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </>
    )
  }

  renderBody = () => {
    const flights = this.getVisibleFlights()
    const columns = [
      {
        title: 'Departure Date/Time(local)',
        dataIndex: 'dept_date',
        key: 'departure',
        align: 'left',
        render: (_, flight) => {
          const departure = flight.latest_dept_date ? moment.utc(flight.latest_dept_date).tz(cookies.get('timezone')).format('DDMMMYY h:mm A') : moment.utc(flight.dept_date).tz(cookies.get('timezone')).format('DDMMMYY h:mm A')
          return <span>{departure.toUpperCase()}</span>
        }
      },
      {
        title: 'Flight #',
        dataIndex: 'flight_num',
        key: 'flight_num',
        width: '12%'
      },
      {
        title: 'City Pair',
        key: 'city_pair',
        render: (_, flight) => `${flight.org_stn} - ${flight.dest_stn}`
      },
      {
        title: '% Compliance',
        key: 'compliance',
        align: 'center',
        render: (_, flight) => {
          const compliance = flight?.scrub_data?.compliance || 0
          return <span className={getComplianceClass(compliance)}>{`${this.formatDecimal(compliance)}%`}</span>
        }
      }
    ]

    return (
      <div className='scm-table-wrap'>
        <div className='table-outer scm-table-wrap'>
          <Table
            className='custom-table scm-table'
            dataSource={flights}
            columns={columns}
            pagination={false}
            rowKey={(record) => record.id || record.key}
            rowSelection={{
              type: 'radio',
              selectedRowKeys: this.state.selectedRowKeys,
              onSelect: (record) => {
                this.handleSelectScrubCopy(record)
              },
            }}
            onRow={(record) => ({ onClick: () => this.handleSelectScrubCopy(record) })}
          />
        </div>
      </div>
    )
  }
  editScrubCopy = (open, record = {}) => {
    this.setState({
      modalVisible: open,
      data: record,
    })
  }

  renderScrubCopy = () => (
    <ScrubCopy
      closeModal={() => this.editScrubCopy(false)}
      data={this.state.data}
      priorityData={this.state.priorityData}
    />
  )

  render() {
    return (
      <div className='position-relative'>
        <div className='scrub-header-search'>
          <Search allowClear className='search-input' placeholder='Search Flight or Destination'
            onChange={this.handleSearch} value={this.state.query}
          />
        </div>
        <Row gutter={[16, 16]}>
          <Col xs={24} xl={10} xxl={9}>
            <Card className='custom-card'>
              <Row gutter={[16, 16]}>
                <Col xs={24}>
                  {this.renderHeader()}
                </Col>
                <Col xs={24}>
                  {this.renderBody()}
                </Col>
              </Row>
            </Card>
          </Col>
          {
            this.state.isModalView ?
              <Modal
                title='Scrub Copy'
                open={this.state.modalVisible}
                onCancel={() => this.editScrubCopy(false)}
                className='custom-modal scrub-copy-modal'
                destroyOnClose={false}
                footer={null}
                width={1000}
                centered
              >
                {this.renderScrubCopy()}
              </Modal>
              :
              <Col xs={0} xl={14} xxl={15}>
                <Card className='custom-card h-100'>
                  <Title level={5}>Scrub Copy</Title>
                  {this.renderScrubCopy()}
                </Card>
            
              </Col>
          }
        </Row>

        
      </div>
    )
  }
}

export default ScrubCopyManager